import { create } from 'zustand'
import {
  createVehicleDataSlice,
  createDamageRegistrationStepSlice,
  createAlertDialogSlice,
  createAddVehicleIdDialogVisibleSlice,
  createVehicleIdSlice,
  createIsKmInputVisibleSlice,
  createMainSlice,
} from './slices'
import createVehiclePhotoDialogSlice, {
  VehiclePhotoDialogSlice,
} from './slices/vehiclePhotoDialog'
import { VehicleIdSlice } from './slices/vehicleId'
import { VehicleDataSlice } from './slices/vehicleData'
import { DamageRegistrationStepSlice } from './slices/damageRegistrationStep'
import { AlertDialogSlice } from './slices/alertDialog'
import { IsAddVehicleIdDialogVisibleSlice } from './slices/addVehicleIdDialogVisible'
import { IsKmInputVisibleSlice } from './slices/isKmInputVisible'
import { MainSlice } from './slices/main'

export interface AppStore
  extends MainSlice,
    VehiclePhotoDialogSlice,
    VehicleIdSlice,
    VehicleDataSlice,
    DamageRegistrationStepSlice,
    AlertDialogSlice,
    IsKmInputVisibleSlice,
    IsAddVehicleIdDialogVisibleSlice {}

export const useAppStore = create<AppStore>((...args) => ({
  ...createMainSlice(...args),
  ...createVehicleDataSlice(...args),
  ...createDamageRegistrationStepSlice(...args),
  ...createAlertDialogSlice(...args),
  ...createAddVehicleIdDialogVisibleSlice(...args),
  ...createVehicleIdSlice(...args),
  ...createIsKmInputVisibleSlice(...args),
  ...createVehiclePhotoDialogSlice(...args),
}))
